import PropTypes from "prop-types";
import React, { Fragment } from "react";
import FormField from "./FormField";
import ComboBox from "react-select";
import { decodeHtmlContent } from "../../../utils";
import { hexToRgb } from "utils/html";

const renderComboBox = ({ value, color, onBlur, onChange, helpText, ...props }) => {
  return (
    <Fragment>
      <ComboBox
        {...props}
        onChange={value => onChange(value && typeof value === "object" ? value.value : value)}
        onBlur={() => onBlur(value)}
        value={value}
        style={{ backgroundColor: (color && hexToRgb(color, 25)) || "" }}
      />
      {helpText && helpText != "#void help text#" && <div className="help-text">{helpText}</div>}
    </Fragment>
  );
};

renderComboBox.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};

const ComboBoxField = ({ items = [], valueKey = "value", labelKey = "label", ...props }) => {
  return (
    <FormField
      component={renderComboBox}
      {...props}
      options={items.map(item => ({
        label: decodeHtmlContent(item[labelKey]),
        value: item[valueKey],
      }))}
    />
  );
};

ComboBoxField.propTypes = {
  items: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
};

export default ComboBoxField;



// WEBPACK FOOTER //
// ./components/common/form-field/ComboBoxField.js